async function saveCompanyInvoiceFields() {
  const companyContactId = window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1]
  if (!companyContactId) return

  const courtInput = document.querySelector('input[data-field-name="gericht"]')
  const directorsSelect = document.querySelector(
    '[data-field-name="geschaeftsfuehrer"] .impowerx-contact-multiselect'
  )

  const data = {
    gericht: courtInput?.value?.trim() || '',
    geschaeftsfuehrer: directorsSelect?.getAttribute('data-selected-ids') || '',
  }

  try {
    const response = await fetch(`${baseApiUrl}/api/impowerX/contacts/${companyContactId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth'))?.token}`,
      },
      body: JSON.stringify({ attributes: data }),
    })

    return await response.json()
  } catch (error) {
    console.error('Failed to save company invoice fields', error)
  }
}

let companyInvoiceEmployeeContactsPromise = null
const companyInvoiceContactByIdPromises = {}

async function getCompanyInvoiceEmployeeContacts() {
  if (!companyInvoiceEmployeeContactsPromise) {
    companyInvoiceEmployeeContactsPromise = getImpowerXData(
      `${baseApiUrl}/api/impowerX/contacts?onlyEmployees=true`
    )
      .then((data) => data?.contacts || [])
      .catch((error) => {
        console.error('Failed to load employee contacts for company invoice fields', error)
        companyInvoiceEmployeeContactsPromise = null
        return []
      })
  }

  return await companyInvoiceEmployeeContactsPromise
}

async function getCompanyInvoiceContactById(contactId) {
  if (!contactId) return null

  if (!companyInvoiceContactByIdPromises[contactId]) {
    companyInvoiceContactByIdPromises[contactId] = getImpowerXData(
      `${baseApiUrl}/api/impowerX/contacts?ids=${contactId}`
    )
      .then((data) => data?.contacts?.[0] || null)
      .catch((error) => {
        console.error('Failed to load company contact for invoice fields', error)
        delete companyInvoiceContactByIdPromises[contactId]
        return null
      })
  }

  return await companyInvoiceContactByIdPromises[contactId]
}

function initializeCompanyInvoiceMultiSelect(field) {
  const root = field.querySelector('.impowerx-contact-multiselect')
  const dropdown = field.querySelector('.contact-multiselect-dropdown')
  const dropdownSearch = field.querySelector('.contact-multiselect-search-wrap .contact-multiselect-search-input')
  const display = field.querySelector('.contact-multiselect-display')
  const placeholder = field.querySelector('.contact-multiselect-placeholder')
  const list = field.querySelector('.contact-multiselect-list')

  if (!root || !dropdown || !display || !placeholder || !list) {
    return
  }

  const escapeHtml = (value = '') =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const getSelectedIds = () =>
    (root.getAttribute('data-selected-ids') || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean)

  const setSelectedIds = (ids) => {
    root.setAttribute('data-selected-ids', ids.join(','))
  }

  const syncDisplay = () => {
    const selectedItems = Array.from(list.querySelectorAll('.contact-multiselect-item-selected'))
    const labels = selectedItems.map((item) => item.getAttribute('data-label') || item.textContent || '')
    display.innerHTML = labels
      .map((label) => `<span class="contact-multiselect-tag" title="${escapeHtml(label)}">${escapeHtml(label)}</span>`)
      .join('')
    display.style.display = labels.length ? 'flex' : 'none'
    placeholder.style.display = labels.length ? 'none' : ''
  }

  const syncSelectedState = () => {
    const selectedIds = getSelectedIds()
    const items = Array.from(list.querySelectorAll('.contact-multiselect-item'))

    items.forEach((item) => {
      const value = String(item.getAttribute('data-value') || '')
      const selected = selectedIds.includes(value)
      item.classList.toggle('ant-select-item-option-selected', selected)
      item.classList.toggle('contact-multiselect-item-selected', selected)
      item.style.backgroundColor = selected ? '#e6f7ff' : ''

      let remove = item.querySelector('.contact-multiselect-remove')
      if (selected && !remove) {
        remove = document.createElement('span')
        remove.className = 'contact-multiselect-remove'
        remove.setAttribute('role', 'button')
        remove.setAttribute('aria-label', 'Remove')
        remove.style.marginLeft = '8px'
        remove.style.cursor = 'pointer'
        remove.style.color = '#999'
        remove.style.fontSize = '16px'
        remove.style.lineHeight = '1'
        remove.textContent = '×'
        item.querySelector('.ant-select-item-option-content')?.appendChild(remove)
      } else if (!selected && remove) {
        remove.remove()
      }
    })

    const selectedItems = items.filter((item) => item.classList.contains('contact-multiselect-item-selected'))
    const unselectedItems = items.filter((item) => !item.classList.contains('contact-multiselect-item-selected'))
    list.innerHTML = ''
    selectedItems.concat(unselectedItems).forEach((item) => list.appendChild(item))
    syncDisplay()
  }

  const closeDropdown = () => {
    dropdown.classList.add('ant-select-dropdown-hidden')
  }

  root.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    dropdown.classList.toggle('ant-select-dropdown-hidden')
    if (!dropdown.classList.contains('ant-select-dropdown-hidden') && dropdownSearch) {
      dropdownSearch.value = ''
      Array.from(list.querySelectorAll('.contact-multiselect-item')).forEach((item) => {
        item.style.display = ''
      })
      syncSelectedState()
      setTimeout(() => dropdownSearch.focus(), 0)
    }
  })

  list.addEventListener('click', (event) => {
    const remove = event.target.closest('.contact-multiselect-remove')
    const item = event.target.closest('.contact-multiselect-item')
    if (!item) return

    event.preventDefault()
    event.stopPropagation()

    const value = String(item.getAttribute('data-value') || '')
    let ids = getSelectedIds()

    if (remove || item.classList.contains('contact-multiselect-item-selected')) {
      ids = ids.filter((id) => id !== value)
    } else {
      ids.push(value)
    }

    setSelectedIds(Array.from(new Set(ids)))
    syncSelectedState()
  })

  if (dropdownSearch) {
    dropdownSearch.addEventListener('input', () => {
      const query = (dropdownSearch.value || '').toLowerCase()
      Array.from(list.querySelectorAll('.contact-multiselect-item')).forEach((item) => {
        const label = (item.getAttribute('data-label') || item.textContent || '').toLowerCase()
        item.style.display = label.includes(query) ? '' : 'none'
      })
    })
  }

  if (!window.__ehvCompanyInvoiceFieldsOutsideClickBound) {
    document.addEventListener('click', (event) => {
      document.querySelectorAll('.company-invoice-fields .contact-multiselect-dropdown').forEach((el) => {
        if (!event.target.closest('.company-invoice-fields .contact-multiselect-case')) {
          el.classList.add('ant-select-dropdown-hidden')
        }
      })
    })
    window.__ehvCompanyInvoiceFieldsOutsideClickBound = true
  }

  syncSelectedState()
  closeDropdown()
}

const initializeCompanyInvoiceFields = async () => {
  const infoDiv = document.querySelector('#info')
  if (!infoDiv) return false

  const currentContactId = window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1]
  if (!currentContactId) return false

  const currentContact = await getCompanyInvoiceContactById(currentContactId)
  if (currentContact?.type !== 'MANAGEMENT_COMPANY') {
    const existingInjectedRow = infoDiv.querySelector('.company-invoice-fields')
    if (existingInjectedRow) {
      existingInjectedRow.remove()
    }
    return false
  }

  const existingInjectedRow = infoDiv.querySelector('.company-invoice-fields')
  const existingCourt = infoDiv.querySelector('[data-field-name="gericht"]')
  const existingDirectors = infoDiv.querySelector('[data-field-name="geschaeftsfuehrer"]')
  const existingRow =
    existingCourt?.closest('.sub-section-content-row') ||
    existingDirectors?.closest('.sub-section-content-row') ||
    existingInjectedRow

  if (existingRow) {
    const hasBothFields = existingCourt && existingDirectors
    const isSameContact = existingRow?._contactId === currentContactId
    const isLoading = existingRow?.dataset?.loading === 'true'

    if ((hasBothFields || isLoading) && isSameContact) return true

    existingRow.remove()
  }

  const subSectionContent = infoDiv.querySelector('.sub-section-content')
  if (!subSectionContent) return false

  const rows = subSectionContent.querySelectorAll('.sub-section-content-row')
  const lastRow = rows[rows.length - 1]
  if (!lastRow) return false

  const invoiceRow = document.createElement('div')
  invoiceRow.className = 'sub-section-content-row company-invoice-fields'
  invoiceRow._contactId = currentContactId
  invoiceRow.dataset.impowerxContactExtra = 'true'
  invoiceRow.dataset.loading = 'true'
  invoiceRow.innerHTML = `
    <div class="company-invoice-court-container"></div>
    <div class="company-invoice-directors-container"></div>
  `

  lastRow.parentNode.insertBefore(invoiceRow, lastRow.nextSibling)

  const contactsData = await getCompanyInvoiceEmployeeContacts()
  const attributesData = await getImpowerXData(
    `${baseApiUrl}/api/impowerX/contacts/${currentContactId}?attributes=gericht,geschaeftsfuehrer`
  ).catch(() => ({}))

  const courtValue = attributesData?.attributes?.find((item) => item.fieldName === 'gericht')?.value || ''
  const directorsValue =
    attributesData?.attributes?.find((item) => item.fieldName === 'geschaeftsfuehrer')?.value || ''

  const directorOptions = (contactsData || []).map((contact) => ({
    value: String(contact.id),
    label: contact.name || `${contact.firstName || ''} ${contact.lastName || ''}`.trim(),
  }))

  const courtField = generateInputField({
    id: 'gericht',
    fieldType: 'TextInput',
    name: 'gericht',
    label: 'Registergericht',
    placeholder: 'Bitte ausfüllen...',
    value: courtValue,
    isDisabled: false,
  })
  courtField.classList.remove('ehv-element')
  courtField.dataset.fieldName = 'gericht'
  courtField.querySelector('input')?.setAttribute('data-field-name', 'gericht')

  const directorsField = generateInputField({
    id: 'geschaeftsfuehrer',
    fieldType: 'ContactMultiSelect',
    name: 'geschaeftsfuehrer',
    label: 'Geschäftsführer',
    placeholder: 'Bitte auswählen oder eintippen...',
    value: directorsValue,
    options: directorOptions,
    isDisabled: false,
  })
  directorsField.classList.remove('ehv-element')
  directorsField.dataset.fieldName = 'geschaeftsfuehrer'

  invoiceRow.querySelector('.company-invoice-court-container')?.replaceWith(courtField)
  invoiceRow.querySelector('.company-invoice-directors-container')?.replaceWith(directorsField)
  invoiceRow.dataset.loading = 'false'

  initializeCompanyInvoiceMultiSelect(directorsField)

  if (!window.__ehvCompanyInvoiceFieldsSaveBound) {
    listenToButtonClick('Speichern', saveCompanyInvoiceFields)
    listenToButtonClick('Speichern und Weiter', saveCompanyInvoiceFields)
    listenToButtonClick('Save', saveCompanyInvoiceFields)
    listenToButtonClick('Save and Continue', saveCompanyInvoiceFields)
    window.__ehvCompanyInvoiceFieldsSaveBound = true
  }

  return true
}
